import { render, staticRenderFns } from "./WT8BookInfo.vue?vue&type=template&id=7795851c&scoped=true"
import script from "./WT8BookInfo.vue?vue&type=script&lang=js"
export * from "./WT8BookInfo.vue?vue&type=script&lang=js"
import style0 from "./WT8BookInfo.vue?vue&type=style&index=0&id=7795851c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7795851c",
  null
  
)

export default component.exports